import { render } from "./HeaderFeanor.vue?vue&type=template&id=04e8475c"
import script from "./HeaderFeanor.vue?vue&type=script&lang=js"
export * from "./HeaderFeanor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__